import axios from "axios";

export default class YachtsService {
  static getB2bItineraries(yachtName) {
    return axios.get("b2b/itineraries/" + yachtName);
  }
}
